import { render, staticRenderFns } from "./marketing-properties-item.vue?vue&type=template&id=11ecbe94&scoped=true&"
import script from "./marketing-properties-item.vue?vue&type=script&lang=js&"
export * from "./marketing-properties-item.vue?vue&type=script&lang=js&"
import style0 from "./marketing-properties-item.vue?vue&type=style&index=0&id=11ecbe94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ecbe94",
  null
  
)

export default component.exports